/*
  SolarGen · DC-Kabel-Auswahl im Set-Konfigurator (siehe snippets/sg-dc-kabel.liquid)
  ----------------------------------------------------------------
  Alle Events laufen per Delegation am document. Der Soft-Swap beim
  Modul-Wechsel ersetzt die ganze Produkt-Section, gebundene Listener
  waeren danach weg; die Delegation ueberlebt das.

  Oeffentliche API fuer die Konfigurator-Snippets:
    SGDcKabel.find(scope)            -> [data-sg-kabel] im Scope oder null
    SGDcKabel.deltaCents(el)         -> Aufpreis in Cent
    SGDcKabel.lengths(el)            -> [2, 2, 5, 5]
    SGDcKabel.setLengths(el, arr)    -> Auswahl uebernehmen (z. B. nach Modul-Wechsel)
    SGDcKabel.cartConfigId(el, vid)  -> gemeinsame ID fuer Set-Zeile und Kabelzeilen
    SGDcKabel.cartItems(el, opts)    -> Positionen fuer cart/add.js

  Aendert sich die Auswahl, feuert 'sg:dc-kabel:change' (bubbelt) am Element.
*/
(function () {
  if (window.SGDcKabel) return;

  function variants(el) {
    if (!el._sgkVariants) {
      try { el._sgkVariants = JSON.parse(el.getAttribute('data-variants') || '[]'); }
      catch (e) { el._sgkVariants = []; }
    }
    return el._sgkVariants;
  }
  function variantFor(el, m) {
    var list = variants(el);
    for (var i = 0; i < list.length; i++) if (list[i].m === m) return list[i];
    return null;
  }
  function lines(el) {
    return Array.prototype.slice.call(el.querySelectorAll('[data-sg-kabel-mod]'));
  }
  function lengths(el) {
    return lines(el).map(function (l) { return parseInt(l.getAttribute('data-value'), 10) || 2; });
  }
  function deltaCents(el) {
    return lengths(el).reduce(function (sum, m) {
      var v = variantFor(el, m);
      return sum + (v ? v.cents : 0);
    }, 0);
  }
  function formatEur(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  /* Zaehlt Laengen: {2: [1, 2], 5: [3, 4]} (Modulnummern ab 1) */
  function groups(el) {
    var out = {};
    lengths(el).forEach(function (m, i) {
      (out[m] = out[m] || []).push(i + 1);
    });
    return out;
  }

  function render(el) {
    var g = groups(el);
    var keys = Object.keys(g).map(Number).sort(function (a, b) { return a - b; });
    var sum = el.querySelector('[data-sg-kabel-sum]');
    if (sum) sum.textContent = keys.map(function (m) { return g[m].length + '× ' + m + ' m'; }).join(', ');

    var delta = deltaCents(el);
    var extra = el.querySelector('[data-sg-kabel-extra]');
    if (extra) extra.textContent = delta > 0 ? '+ ' + formatEur(delta) : '';
    var sub = el.querySelector('[data-sg-kabel-sub]');
    if (sub) sub.textContent = delta > 0 ? 'Aufpreis gegenüber 2 m inklusive' : '1 Kabelpaar pro Modul inklusive';

    lines(el).forEach(function (line) {
      var m = String(parseInt(line.getAttribute('data-value'), 10) || 2);
      var sel = line.querySelector('select');
      if (sel && sel.value !== m) sel.value = m;
      line.classList.toggle('is-changed', m !== '2');
    });

    /* "Alle Module" zeigt die gemeinsame Laenge, bei gemischter Wahl "unterschiedlich" */
    var all = el.querySelector('[data-sg-kabel-all]');
    if (all) {
      var ls = lengths(el);
      var same = ls.every(function (m) { return m === ls[0]; });
      all.value = same ? String(ls[0]) : '';
    }
  }

  function changed(el) {
    render(el);
    el.dispatchEvent(new CustomEvent('sg:dc-kabel:change', { bubbles: true, detail: { deltaCents: deltaCents(el) } }));
  }

  function setLengths(el, arr) {
    if (!el || !arr || !arr.length) return;
    var uniform = arr.every(function (m) { return m === arr[0]; });
    lines(el).forEach(function (line, i) {
      var m = uniform ? arr[0] : (arr[i] || 2);
      if (variantFor(el, m)) line.setAttribute('data-value', String(m));
    });
    if (!lengths(el).every(function (m) { return m === 2; })) openPanel(el, true);
    changed(el);
  }

  function openPanel(el, open) {
    var panel = el.querySelector('[data-sg-kabel-panel]');
    var btn = el.querySelector('[data-sg-kabel-toggle]');
    if (!panel || !btn) return;
    panel.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.textContent = open ? 'Fertig' : 'Längen anpassen';
  }

  /* Gleiche Konfiguration -> gleiche ID, damit Shopify identische Sets
     zusammenfasst und unterschiedliche getrennt haelt. */
  function cartConfigId(el, mainVariantId) {
    return String(mainVariantId) + ':' + lengths(el).join('-');
  }

  /* Eine Warenkorb-Position pro Laenge. Menge = Anzahl Module mit dieser
     Laenge x Set-Menge. _sg_kabel_cfg verbindet sie mit der Set-Zeile,
     _sg_kabel_pro_set erlaubt dem Guard, die Menge nachzuziehen. */
  function cartItems(el, opts) {
    opts = opts || {};
    var mainQty = Math.max(1, parseInt(opts.mainQty, 10) || 1);
    var cfg = cartConfigId(el, opts.mainVariantId || 0);
    var g = groups(el);
    return Object.keys(g).map(Number).sort(function (a, b) { return a - b; }).map(function (m) {
      var v = variantFor(el, m);
      if (!v) return null;
      return {
        id: v.id,
        quantity: g[m].length * mainQty,
        properties: {
          'Module': g[m].join(', '),
          _addon_for: opts.mainTitle || '',
          _sg_kabel_cfg: cfg,
          _sg_kabel_pro_set: String(g[m].length)
        }
      };
    }).filter(Boolean);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-sg-kabel-toggle]') : null;
    if (!btn) return;
    var el = btn.closest('[data-sg-kabel]');
    if (!el) return;
    e.preventDefault();
    openPanel(el, btn.getAttribute('aria-expanded') !== 'true');
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || t.tagName !== 'SELECT') return;
    var el = t.closest('[data-sg-kabel]');
    if (!el || !t.value) return;
    if (t.matches('[data-sg-kabel-all]')) {
      lines(el).forEach(function (line) { line.setAttribute('data-value', t.value); });
    } else {
      var line = t.closest('[data-sg-kabel-mod]');
      if (!line) return;
      line.setAttribute('data-value', t.value);
    }
    changed(el);
  });

  window.SGDcKabel = {
    find: function (scope) { return (scope || document).querySelector('[data-sg-kabel]'); },
    deltaCents: deltaCents,
    lengths: lengths,
    setLengths: setLengths,
    cartConfigId: cartConfigId,
    cartItems: cartItems
  };
  document.dispatchEvent(new CustomEvent('sg:dc-kabel:ready'));
})();
